import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { Trans } from 'lingui-react';
import { compose, setDisplayName } from 'recompose';

import { Column, Row } from 'styled-components-reactive-grid';
import { Badge, Text } from 'base-components';

import { PAYMENT_METHODS } from '../constants';
import withSetPaymentDetails from '../withSetPaymentDetails';

class NationalNoCreditCard extends PureComponent {
  static propTypes = {
    paymentMethod: PropTypes.string.isRequired,
    setPaymentDetails: PropTypes.func.isRequired,
  };

  componentWillMount() {
    if (this.props.paymentMethod !== PAYMENT_METHODS.MICHELIN_LINE_OF_CREDIT) {
      this.props.setPaymentDetails({
        paymentMethod: PAYMENT_METHODS.MICHELIN_LINE_OF_CREDIT,
      });
    }
  }

  render() {
    return (
      <Row modifiers={['middle', 'padScaleY_2']}>
        <Column>
          <Badge modifiers={['success']}>
            <Badge.Icon name="service-provider" />
          </Badge>
        </Column>
        <Column>
          <Text>
            <Trans>National Account</Trans>
          </Text>
        </Column>
      </Row>
    );
  }
}

export default compose(
  setDisplayName('NationalNoCreditCard'),
  withSetPaymentDetails,
)(NationalNoCreditCard);



// WEBPACK FOOTER //
// ./src/compositions/CasePaymentPanel/AccountType/NationalNoCreditCard.js